// Entry of the <script> build: the class itself becomes `window.ScrollBooster`
import { ScrollBooster } from './scroll-booster';

export default ScrollBooster;
